module.exports = __webpack_public_path__ + "media/images/flags/16/Turks-and-Caicos-Islands-774a57b3bdb5457c0cc866782d76503d.png";